import type { ShipmentRow } from '#/entities/shipment'
import { useGetMeApiV1UsersMeGet } from '#/shared/api/generated/auth/theCargoAuth'
import type { MassRecipientInput } from '#/shared/api/generated/communication/models'
import { useWorkspaceTabState } from '#/shared/lib/workspace-tabs'

import type { MassEmailViewModel } from '../lib/mass-email'

export interface UseMassEmailActionResult {
  open: boolean
  openEmail: () => void
  onOpenChange: (open: boolean) => void
  viewModel: MassEmailViewModel
}

function toEmailRecipients(
  rows: ShipmentRow[],
  selectedIds: string[],
): MassRecipientInput[] {
  const selected = new Set(selectedIds)
  return rows
    .filter((row) => selected.has(row.id) && row.customerEmail)
    .map((row) => ({
      contact: row.customerEmail,
      name: row.customerName || null,
      shipment_id: row.shipmentId,
      customer_id: row.customerId || null,
    }))
}

export function useMassEmailAction(
  rows: ShipmentRow[],
  selectedIds: string[],
): UseMassEmailActionResult {
  // Per workspace tab, so a mass-email left open comes back when the user
  // switches to another workspace tab and returns.
  const [open, setOpen] = useWorkspaceTabState('massEmailOpen', false)
  const { data } = useGetMeApiV1UsersMeGet()
  const email = data?.data.email
  return {
    open,
    openEmail: () => setOpen(true),
    onOpenChange: setOpen,
    viewModel: {
      fromEmails: email ? [email] : [],
      recipients: toEmailRecipients(rows, selectedIds),
    },
  }
}
